import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, Output, ViewChild, Input, NgModule, Pipe, ViewContainerRef } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@ionic/angular';
import { IonicModule, IonInfiniteScroll } from '@ionic/angular';
import * as i2 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from 'ngx-quill';
import { QuillModule } from 'ngx-quill';
import * as i2$1 from 'ngx-image-cropper';
import { ImageCropperModule } from 'ngx-image-cropper';
import { __awaiter } from 'tslib';
import { CameraResultType, Camera } from '@capacitor/camera';
import { BehaviorSubject } from 'rxjs';

class OctaliLibUtilsService {
    constructor() { }
}
OctaliLibUtilsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OctaliLibUtilsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class OctaliLibUtilsComponent {
    constructor() { }
    ngOnInit() {
    }
}
OctaliLibUtilsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OctaliLibUtilsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: OctaliLibUtilsComponent, selector: "ctl-octali-lib-utils", ngImport: i0, template: `
    <p>
      octali-lib-utils works!
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ctl-octali-lib-utils',
                    template: `
    <p>
      octali-lib-utils works!
    </p>
  `,
                    styles: []
                }]
        }], ctorParameters: function () { return []; } });

/*import * as QuillNamespace from 'quill';
let Quill: any = QuillNamespace;
//import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';
Quill.register('modules/imageResize', ImageResize);
import QuillEmoji from "quill-emoji";
Quill.register("modules/emoji", QuillEmoji);*/
class TextRichEditorComponent {
    constructor() {
        this.content = new EventEmitter();
        this.text = '';
        this.modules = {
            imageResize: true,
            'emoji-shortname': true,
            'emoji-textarea': false,
            'emoji-toolbar': true,
            'toolbar': {
                container: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'direction': 'rtl' }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['clean'],
                    ['link', 'image', 'video'],
                    ['emoji'],
                ],
                handlers: { 'emoji': function () { } }
            }
        };
        this.onSelectionChanged = (event) => { };
        this.onContentChanged = (event) => {
            this.text = event.html;
            this.content.emit(this.text);
        };
    }
    ngOnInit() {
    }
    setText(text) {
        this.text = text;
    }
    editorCreated(quill) { }
}
TextRichEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichEditorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TextRichEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: TextRichEditorComponent, selector: "ctl-text-rich-editor", inputs: { text: "text" }, outputs: { content: "content" }, viewQueries: [{ propertyName: "editor", first: true, predicate: ["editor"], descendants: true }], ngImport: i0, template: "<div>\n    <!-- Text Editor -->\n    <quill-editor #editor [modules]=\"modules\" (onEditorCreated)=\"editorCreated($event)\" placeholder=\"Entrez votre texte\"\n        (onSelectionChanged)=\"onSelectionChanged($event)\" (onContentChanged)=\"onContentChanged($event)\" name=\"content\"\n         [(ngModel)]=\"text\">\n    </quill-editor>\n</div>", styles: ["quill-editor{min-height:350px!important}\n"], components: [{ type: i1.QuillEditorComponent, selector: "quill-editor" }], directives: [{ type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ctl-text-rich-editor', template: "<div>\n    <!-- Text Editor -->\n    <quill-editor #editor [modules]=\"modules\" (onEditorCreated)=\"editorCreated($event)\" placeholder=\"Entrez votre texte\"\n        (onSelectionChanged)=\"onSelectionChanged($event)\" (onContentChanged)=\"onContentChanged($event)\" name=\"content\"\n         [(ngModel)]=\"text\">\n    </quill-editor>\n</div>", styles: ["quill-editor{min-height:350px!important}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { content: [{
                type: Output
            }], editor: [{
                type: ViewChild,
                args: ['editor']
            }], text: [{
                type: Input
            }] } });

class TextRichEditorComponentModule {
}
TextRichEditorComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichEditorComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TextRichEditorComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichEditorComponentModule, declarations: [TextRichEditorComponent], imports: [CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule, i1.QuillModule], exports: [TextRichEditorComponent] });
TextRichEditorComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichEditorComponentModule, providers: [], imports: [[
            CommonModule,
            IonicModule,
            FormsModule,
            ReactiveFormsModule,
            QuillModule.forRoot({
                modules: {
                    syntax: true
                }
            })
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichEditorComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TextRichEditorComponent,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FormsModule,
                        ReactiveFormsModule,
                        QuillModule.forRoot({
                            modules: {
                                syntax: true
                            }
                        })
                    ],
                    providers: [],
                    exports: [
                        TextRichEditorComponent,
                    ],
                    entryComponents: [],
                }]
        }] });

class TextPopoverComponent {
    constructor(navParams) {
        this.message = navParams.get('message');
    }
    ngOnInit() {
    }
}
TextPopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextPopoverComponent, deps: [{ token: i1$1.NavParams }], target: i0.ɵɵFactoryTarget.Component });
TextPopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: TextPopoverComponent, selector: "ctl-text-popover", ngImport: i0, template: "<p>\n    {{message}}\n</p>\n  ", styles: ["p{padding:1em;margin:0;text-align:justify;font-size:.9em;background-color:#000a;color:#fff}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ctl-text-popover', template: "<p>\n    {{message}}\n</p>\n  ", styles: ["p{padding:1em;margin:0;text-align:justify;font-size:.9em;background-color:#000a;color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.NavParams }]; } });

class TextPopoverComponentModule {
}
TextPopoverComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextPopoverComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TextPopoverComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextPopoverComponentModule, declarations: [TextPopoverComponent], imports: [CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule], exports: [TextPopoverComponent] });
TextPopoverComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextPopoverComponentModule, providers: [], imports: [[
            CommonModule,
            IonicModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextPopoverComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TextPopoverComponent,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    providers: [],
                    exports: [
                        TextPopoverComponent
                    ],
                    entryComponents: [],
                }]
        }] });

class CalculatorComponent {
    constructor() {
        this.operator = true; //--< affiche les boutons d'operation ou non
        this.disabled = false;
        this.result = new EventEmitter(); //--> emet le résultat de l'operation
        this.display = 0; //--< nombre affiche a l'ecran
        this.total = 0; //--< resultat de l'operation
        this.ope = ""; //--< operateur utilise
        this.decimal = false; //--< mode decimale ou non
        this.nbDecimal = 0; //--< nombre de decimales
        this.chiffre1 = 0; //--< chiffre tape apres l'operateur
        this.chiffre2 = 0; //--< chifre tape avant l'operateur
    }
    ngOnInit() {
    }
    /**
     * Fonction qui bascule la saisie en décimale ou non
     */
    setDecimal() {
        if (this.nbDecimal == 0)
            this.decimal = !this.decimal;
    }
    /**
     * Fonction qui défini l'opérateur a utiliser.
     * Bascule le chiffre a l'ecran, et reinitialise les decimales
     * @param ope operateur a utiliser
     */
    setOperator(ope) {
        this.ope = ope;
        this.display = this.chiffre2;
        this.decimal = false;
        this.nbDecimal = 0;
    }
    /**
     * Fonction qui calcul l'operation
     */
    calcul() {
        switch (this.ope) {
            case "+":
                this.total = this.chiffre1 + this.chiffre2;
                break;
            case "-":
                this.total = this.chiffre1 - this.chiffre2;
                break;
            case "x":
                this.total = this.chiffre1 * this.chiffre2;
                break;
            case "/":
                this.total = this.chiffre1 / this.chiffre2;
                break;
        }
        this.display = this.total;
        this.chiffre1 = this.total;
        this.chiffre2 = 0;
        this.ope = "";
        this.decimal = false;
        this.nbDecimal = 0;
    }
    /**
     * Fonction qui saisie un chiffre
     * @param num chiffre saisi
     */
    chiffre(num) {
        const format = (num, nbDecimal) => num.toLocaleString('en-US', {
            minimumFractionDigits: 1,
            maximumFractionDigits: nbDecimal,
        });
        if (this.ope == "") {
            if (this.decimal) {
                this.nbDecimal += 1;
                this.chiffre1 = parseFloat(format(this.chiffre1 + num / Math.pow(10, this.nbDecimal), this.nbDecimal).replace(/,/g, ''));
            }
            else
                this.chiffre1 = this.chiffre1 * 10 + num;
            this.display = this.chiffre1;
            this.total = this.chiffre1;
        }
        else {
            if (this.decimal) {
                this.nbDecimal += 1;
                this.chiffre2 = parseFloat(format(this.chiffre2 + num / Math.pow(10, this.nbDecimal), this.nbDecimal).replace(/,/g, ''));
            }
            else
                this.chiffre2 = this.chiffre2 * 10 + num;
            this.display = this.chiffre2;
        }
    }
    /**
     * Fonction qui reinitialise le calcul
     */
    reset() {
        this.total = 0;
        this.display = 0;
        this.decimal = false;
        this.nbDecimal = 0;
        this.chiffre1 = 0;
        this.chiffre2 = 0;
        this.ope = "";
    }
    /**
     * Fonction qui supprime le dernier chiffre
     */
    remove() {
        let s = this.display.toString();
        if (s.length == 1)
            this.display = 0;
        else {
            this.display = parseFloat(s.substr(0, s.length - 1));
            if (this.decimal) {
                this.nbDecimal -= 1;
                if (this.nbDecimal == 0) {
                    this.decimal = false;
                }
            }
            if (this.ope == "") {
                this.chiffre1 = this.display;
                this.total = this.chiffre1;
            }
            else
                this.chiffre2 = this.display;
        }
    }
    /**
     * Fonction qui émet le résultat
     */
    getResult() {
        this.result.emit(this.total);
    }
}
CalculatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CalculatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CalculatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: CalculatorComponent, selector: "ctl-calculator", inputs: { operator: "operator", disabled: "disabled" }, outputs: { result: "result" }, ngImport: i0, template: "<ion-grid>\n    <ion-row>\n      <ion-col>\n        <ion-input class=\"total\" #result type=\"number\" [ngModel]=\"display\" [disabled]=\"disabled\"></ion-input>\n      </ion-col>\n      <ion-col  *ngIf=\"operator\" size=\"1\">\n        {{ope}}\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button fill=\"clear\" (click)=\"remove()\" [disabled]=\"disabled\">\n          <ion-icon slot=\"icon-only\" name=\"arrow-back-circle-outline\"></ion-icon>\n        </ion-button>\n      </ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col><ion-button (click)=\"chiffre(1)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">1</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(2)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">2</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(3)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">3</ion-button></ion-col>\n      <ion-col *ngIf=\"operator\"><ion-button (click)=\"setOperator('+')\"fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">+</ion-button></ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col><ion-button (click)=\"chiffre(4)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">4</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(5)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">5</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(6)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">6</ion-button></ion-col>\n      <ion-col *ngIf=\"operator\"><ion-button (click)=\"setOperator('-')\" fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">-</ion-button></ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col><ion-button (click)=\"chiffre(7)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">7</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(8)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">8</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(9)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">9</ion-button></ion-col>\n      <ion-col *ngIf=\"operator\"><ion-button (click)=\"setOperator('x')\"fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">x</ion-button></ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col><ion-button (click)=\"reset()\" fill=\"outline\"class=\"ope\" expand=\"block\" [disabled]=\"disabled\">C</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(0)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">0</ion-button></ion-col>\n      <ion-col *ngIf=\"!decimal\"><ion-button (click)=\"setDecimal()\" fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">.</ion-button></ion-col>\n      <ion-col *ngIf=\"decimal\"><ion-button (click)=\"setDecimal()\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">.</ion-button></ion-col>\n      <ion-col *ngIf=\"operator\"><ion-button (click)=\"setOperator('/')\" fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">/</ion-button></ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col *ngIf=\"ope == ''\"><ion-button (click)=\"getResult()\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\"><i slot=\"icon-only\" class=\"fas fa-check-circle\"></i></ion-button></ion-col>\n      <ion-col *ngIf=\"ope != ''\"><ion-button (click)=\"calcul()\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">=</ion-button></ion-col>\n    </ion-row>\n  </ion-grid>", styles: ["ion-grid,ion-row,ion-col{width:100%}.ope,.chiffre{font-weight:700;font-size:1.2em}.total{font-size:1.5em;font-weight:700;color:var(--ion-color-primary)}\n"], components: [{ type: i1$1.IonGrid, selector: "ion-grid", inputs: ["fixed"] }, { type: i1$1.IonRow, selector: "ion-row" }, { type: i1$1.IonCol, selector: "ion-col", inputs: ["offset", "offsetLg", "offsetMd", "offsetSm", "offsetXl", "offsetXs", "pull", "pullLg", "pullMd", "pullSm", "pullXl", "pullXs", "push", "pushLg", "pushMd", "pushSm", "pushXl", "pushXs", "size", "sizeLg", "sizeMd", "sizeSm", "sizeXl", "sizeXs"] }, { type: i1$1.IonInput, selector: "ion-input", inputs: ["accept", "autocapitalize", "autocomplete", "autocorrect", "autofocus", "clearInput", "clearOnEdit", "color", "debounce", "disabled", "enterkeyhint", "inputmode", "max", "maxlength", "min", "minlength", "mode", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "spellcheck", "step", "type", "value"] }, { type: i1$1.IonButton, selector: "ion-button", inputs: ["buttonType", "color", "disabled", "download", "expand", "fill", "href", "mode", "rel", "routerAnimation", "routerDirection", "shape", "size", "strong", "target", "type"] }, { type: i1$1.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }], directives: [{ type: i1$1.NumericValueAccessor, selector: "ion-input[type=number]" }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CalculatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ctl-calculator', template: "<ion-grid>\n    <ion-row>\n      <ion-col>\n        <ion-input class=\"total\" #result type=\"number\" [ngModel]=\"display\" [disabled]=\"disabled\"></ion-input>\n      </ion-col>\n      <ion-col  *ngIf=\"operator\" size=\"1\">\n        {{ope}}\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button fill=\"clear\" (click)=\"remove()\" [disabled]=\"disabled\">\n          <ion-icon slot=\"icon-only\" name=\"arrow-back-circle-outline\"></ion-icon>\n        </ion-button>\n      </ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col><ion-button (click)=\"chiffre(1)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">1</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(2)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">2</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(3)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">3</ion-button></ion-col>\n      <ion-col *ngIf=\"operator\"><ion-button (click)=\"setOperator('+')\"fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">+</ion-button></ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col><ion-button (click)=\"chiffre(4)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">4</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(5)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">5</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(6)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">6</ion-button></ion-col>\n      <ion-col *ngIf=\"operator\"><ion-button (click)=\"setOperator('-')\" fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">-</ion-button></ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col><ion-button (click)=\"chiffre(7)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">7</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(8)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">8</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(9)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">9</ion-button></ion-col>\n      <ion-col *ngIf=\"operator\"><ion-button (click)=\"setOperator('x')\"fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">x</ion-button></ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col><ion-button (click)=\"reset()\" fill=\"outline\"class=\"ope\" expand=\"block\" [disabled]=\"disabled\">C</ion-button></ion-col>\n      <ion-col><ion-button (click)=\"chiffre(0)\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">0</ion-button></ion-col>\n      <ion-col *ngIf=\"!decimal\"><ion-button (click)=\"setDecimal()\" fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">.</ion-button></ion-col>\n      <ion-col *ngIf=\"decimal\"><ion-button (click)=\"setDecimal()\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">.</ion-button></ion-col>\n      <ion-col *ngIf=\"operator\"><ion-button (click)=\"setOperator('/')\" fill=\"outline\" class=\"ope\" expand=\"block\" [disabled]=\"disabled\">/</ion-button></ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col *ngIf=\"ope == ''\"><ion-button (click)=\"getResult()\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\"><i slot=\"icon-only\" class=\"fas fa-check-circle\"></i></ion-button></ion-col>\n      <ion-col *ngIf=\"ope != ''\"><ion-button (click)=\"calcul()\" class=\"chiffre\" expand=\"block\" [disabled]=\"disabled\">=</ion-button></ion-col>\n    </ion-row>\n  </ion-grid>", styles: ["ion-grid,ion-row,ion-col{width:100%}.ope,.chiffre{font-weight:700;font-size:1.2em}.total{font-size:1.5em;font-weight:700;color:var(--ion-color-primary)}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { operator: [{
                type: Input
            }], disabled: [{
                type: Input
            }], result: [{
                type: Output
            }] } });

class CalculatorComponentModule {
}
CalculatorComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CalculatorComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CalculatorComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CalculatorComponentModule, declarations: [CalculatorComponent], imports: [CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule], exports: [CalculatorComponent] });
CalculatorComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CalculatorComponentModule, providers: [], imports: [[
            CommonModule,
            IonicModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CalculatorComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CalculatorComponent,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    providers: [],
                    exports: [
                        CalculatorComponent
                    ],
                    entryComponents: [],
                }]
        }] });

class SortPipe {
    transform(array, args) {
        return array.sort(function (a, b) {
            if (!a[args.property])
                return -1 * args.order;
            if (!b[args.property])
                return 1 * args.order;
            if (Number(a[args.property])) {
                if (a[args.property] - b[args.property] < 0) {
                    return -1 * args.order;
                }
                else if (a[args.property] - b[args.property] > 0) {
                    return 1 * args.order;
                }
                else {
                    return 0;
                }
            }
            else if (Array.isArray(a[args.property])) {
                if (Number(a[args.property][0])) {
                    if (a[args.property][0] - b[args.property][0] < 0) {
                        return -1 * args.order;
                    }
                    else if (a[args.property][0] - b[args.property][0] > 0) {
                        return 1 * args.order;
                    }
                    else {
                        return 0;
                    }
                }
                else {
                    if (a[args.property][0].toLowerCase() < b[args.property][0].toLowerCase()) {
                        return -1 * args.order;
                    }
                    else if (a[args.property][0].toLowerCase() > b[args.property][0].toLowerCase()) {
                        return 1 * args.order;
                    }
                    else {
                        return 0;
                    }
                }
            }
            else if (a[args.property].toLowerCase() < b[args.property].toLowerCase()) {
                return -1 * args.order;
            }
            else if (a[args.property].toLowerCase() > b[args.property].toLowerCase()) {
                return 1 * args.order;
            }
            else {
                return 0;
            }
        });
    }
}
SortPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SortPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortPipe, name: "sort" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sort'
                }]
        }] });

class SortValuePipe {
    transform(array, args) {
        return array.sort(function (a, b) {
            if (Number(a) && Number(b)) {
                if (a - b < 0) {
                    return -1 * args.order;
                }
                else if (a - b > 0) {
                    return 1 * args.order;
                }
                else {
                    return 0;
                }
            }
            else {
                if (Array.isArray(a)) {
                    if (Number(a[0]) && Number(b[0])) {
                        if (a[0] - b[0] < 0) {
                            return -1 * args.order;
                        }
                        else if (a[0] - b[0] > 0) {
                            return 1 * args.order;
                        }
                        else
                            return 0;
                    }
                    else {
                        if (a[0].toLowerCase() < b[0].toLowerCase()) {
                            return -1 * args.order;
                        }
                        else if (a[0].toLowerCase() > b[0].toLowerCase()) {
                            return 1 * args.order;
                        }
                        else {
                            return 0;
                        }
                    }
                }
                else {
                    if (a.toLowerCase() < b.toLowerCase()) {
                        return -1 * args.order;
                    }
                    else if (a.toLowerCase() > b.toLowerCase()) {
                        return 1 * args.order;
                    }
                    else {
                        return 0;
                    }
                }
            }
        });
    }
}
SortValuePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortValuePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SortValuePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortValuePipe, name: "sortValue" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortValuePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sortValue'
                }]
        }] });

class SortMapPipe {
    transform(array, args) {
        return array.sort(function (a, b) {
            if (Number(a.values.get(args.key))) {
                if (a.values.get(args.key) - b.values.get(args.key) < 0) {
                    return -1 * args.order;
                }
                else if (a.values.get(args.key) - b.values.get(args.key) > 0) {
                    return 1 * args.order;
                }
                else {
                    return 0;
                }
            }
            if (a.values.get(args.key).toLowerCase() < b.values.get(args.key).toLowerCase()) {
                return -1 * args.order;
            }
            else if (a.values.get(args.key).toLowerCase() > b.values.get(args.key).toLowerCase()) {
                return 1 * args.order;
            }
            else {
                return 0;
            }
        });
    }
}
SortMapPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortMapPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SortMapPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortMapPipe, name: "sortMap" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortMapPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sortMap'
                }]
        }] });

class SortKeyPipe {
    transform(array, args) {
        if (array == null || array == undefined)
            return array;
        return array.sort(function (a, b) {
            if (Number(a.key[args.key])) {
                if (a.key[args.key] - b.key[args.key] < 0) {
                    return -1 * args.order;
                }
                else if (a.key[args.key] - b.key[args.key] > 0) {
                    return 1 * args.order;
                }
                else {
                    return 0;
                }
            }
            if (a.key[args.key].toLowerCase() < b.key[args.key].toLowerCase()) {
                return -1 * args.order;
            }
            else if (a.key[args.key].toLowerCase() > b.key[args.key].toLowerCase()) {
                return 1 * args.order;
            }
            else {
                return 0;
            }
        });
    }
}
SortKeyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortKeyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SortKeyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortKeyPipe, name: "sortKey" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortKeyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sortKey'
                }]
        }] });

class SearchPipe {
    transform(items, args) {
        if (!items)
            return [];
        if (!args.terms)
            return items;
        args.terms = args.terms.toLowerCase();
        return items.filter(it => {
            return it[args.property].toLowerCase().includes(args.terms); // only filter country name
        });
    }
}
SearchPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SearchPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchPipe, name: "search" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'search'
                }]
        }] });

class SearchValuePipe {
    transform(items, args) {
        if (!items)
            return [];
        if (!args.terms)
            return items;
        args.terms = args.terms.toLowerCase();
        return items.filter(it => {
            return it.toLowerCase().includes(args.terms); // only filter country name
        });
    }
}
SearchValuePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchValuePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SearchValuePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchValuePipe, name: "searchValue" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchValuePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'searchValue'
                }]
        }] });

class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: PipesModule, declarations: [SortPipe,
        SortValuePipe,
        SortMapPipe,
        SortKeyPipe,
        SearchPipe,
        SearchValuePipe], imports: [CommonModule], exports: [SortPipe,
        SortValuePipe,
        SortMapPipe,
        SortKeyPipe,
        SearchPipe,
        SearchValuePipe] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: PipesModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SortPipe,
                        SortValuePipe,
                        SortMapPipe,
                        SortKeyPipe,
                        SearchPipe,
                        SearchValuePipe,
                    ],
                    imports: [CommonModule],
                    exports: [
                        SortPipe,
                        SortValuePipe,
                        SortMapPipe,
                        SortKeyPipe,
                        SearchPipe,
                        SearchValuePipe
                    ]
                }]
        }] });

class FilePickerComponent {
    constructor() {
        this.imgSrc = null; //--< image source
        this.croppedImage = new EventEmitter(); //--< emetteur de l'image retouchee
        this.imgTemp = null; //--< image sur laquelle on travail (au début = imgSrc)
        this.imgTempUrl = null; //--< image sur laquelle on travail (au début = imgSrc)
        this.transform = {}; //--< transformation du cropper
        this.canvasRotation = 0; //--< angle de rotation du cropper
        this.scale = 1; //--< zoom sur le cropper
        this.ratio = 1; //--< ratio du cropper
        this.maintainAspectRatio = true; //--< indique si on conserve l'aspect du ratio
        this.imageChangedEvent = ''; //--< image issu d'un changement
        this.imgTemp = null;
    }
    ngOnInit() {
        this.temp();
    }
    /**
     * fonction qui permet de réinitialier l'image.
     */
    reset() {
        this.scale = 1;
        this.canvasRotation = 0;
        this.transform = {};
        if (this.imgSrc.substring(0, 4) == "data")
            this.imgTemp = this.imgSrc;
        else
            this.imgTempUrl = this.imgSrc;
    }
    /**
     * Fonction qui permet de tourner l'image de 90 degré
     * @param sens sens de rotation (-1 = sens des aiguille d'une montre; 1 = sene inverse)
     */
    rotate(sens) {
        this.canvasRotation += sens;
        this.flipAfterRotate();
    }
    /**
     * Fonction qui permet de dézoomer sur l'image
     */
    zoomOut() {
        this.scale -= .1;
        this.transform = Object.assign(Object.assign({}, this.transform), { scale: this.scale });
    }
    /**
     * Fonction qui permet de zoomer sur l'image
     */
    zoomIn() {
        this.scale += .1;
        this.transform = Object.assign(Object.assign({}, this.transform), { scale: this.scale });
    }
    /**
     * Fonction qui permet de fixer le ratio du cropper
     * @param ratio 0 = sélection libre ; 1 = ration fixe (1/1) ; 4/3...
     */
    setRatio(ratio) {
        if (ratio == 0)
            this.maintainAspectRatio = false;
        else {
            this.maintainAspectRatio = true;
            this.ratio = ratio;
        }
    }
    /**
     * Fonction qui remplace l'image source par l'image retouche
     */
    temp() {
        if (this.imgSrc.substring(0, 4) == "data")
            this.imgTemp = this.imgSrc;
        else
            this.imgTempUrl = this.imgSrc;
    }
    /**
     * Fonction qui sauvegarde l'image retouchee
     */
    save() {
        this.imgTemp = this.imgResult;
        this.croppedImage.emit(this.imgResult);
    }
    /**
     * Fonction qui permet la rotation de l'image
     */
    flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = Object.assign(Object.assign({}, this.transform), { flipH: flippedV, flipV: flippedH });
    }
    /**
     * Fonction appelee lors d'un changement de l'image
     * @param event
     */
    fileChangeEvent(event) {
        this.imageChangedEvent = event;
    }
    /**
     * Fonction appelee a chaque mouvement du cropper
     * @param event
     */
    imageCropped(event) {
        this.imgResult = event.base64;
    }
    /**
     * Fonction appelee lorsque que l'image est chargee
     */
    imageLoaded() {
        // show cropper
    }
    /**
     * Fonction appelee lorsque le cropper est pret
     */
    cropperReady() {
        // cropper ready
        console.log("ready");
    }
    /**
     * Fonction appelee lorsqu'il y a une erreur lor du chargement de l'image
     */
    loadImageFailed() {
        // show message
    }
}
FilePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FilePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FilePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: FilePickerComponent, selector: "ctl-file-picker", inputs: { imgSrc: "imgSrc" }, outputs: { croppedImage: "croppedImage" }, ngImport: i0, template: "<div ion-fixed><ion-grid>\n    <ion-row>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"setRatio(1)\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-expand\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"setRatio(0)\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-compress\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\"  color=\"primary\" (click)=\"zoomIn()\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-search-plus\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"zoomOut()\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-search-minus\"></ion-icon> \n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"rotate(-1)\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-undo\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"rotate(1)\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-redo\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      </ion-row>\n\n      <ion-row>\n        <ion-col size=\"4\">\n          <ion-button size=\"small\" expand=\"full\" fill=\"clear\" color=\"primary\" (click)=\"reset()\">\n            <ion-icon slot=\"icon-only\" class=\"fas fa-trash\"></ion-icon>\n          </ion-button>\n        </ion-col>\n      <ion-col size=\"4\">\n        <ion-button size=\"small\" expand=\"full\" fill=\"clear\" color=\"primary\" (click)=\"temp()\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-expand-arrows-alt\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"4\">\n        <ion-button size=\"small\" expand=\"full\" fill=\"clear\" color=\"primary\" (click)=\"save()\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-save\"></ion-icon>\n        </ion-button>\n      </ion-col>\n    \n    </ion-row>\n</ion-grid>\n</div>\n\n<image-cropper [hidden]=\"imgTemp == null\"\n    [imageBase64]=\"imgTemp\"\n    [imageChangedEvent]=\"imageChangedEvent\"\n    [maintainAspectRatio]=\"maintainAspectRatio\"\n    [aspectRatio]=\"ratio\"\n    format=\"png\"\n    (imageCropped)=\"imageCropped($event)\"\n    (imageLoaded)=\"imageLoaded()\"\n    (cropperReady)=\"cropperReady()\"\n    (loadImageFailed)=\"loadImageFailed()\"\n    [canvasRotation]=\"canvasRotation\"\n    [transform]=\"transform\"\n></image-cropper>\n\n<image-cropper [hidden]=\"imgTemp != null\"\n    [imageURL]=\"imgTempUrl\"\n    [imageChangedEvent]=\"imageChangedEvent\"\n    [maintainAspectRatio]=\"maintainAspectRatio\"\n    [aspectRatio]=\"ratio\"\n    format=\"png\"\n    (imageCropped)=\"imageCropped($event)\"\n    (imageLoaded)=\"imageLoaded()\"\n    (cropperReady)=\"cropperReady()\"\n    (loadImageFailed)=\"loadImageFailed()\"\n    [canvasRotation]=\"canvasRotation\"\n    [transform]=\"transform\"\n></image-cropper>\n\n", styles: [""], components: [{ type: i1$1.IonGrid, selector: "ion-grid", inputs: ["fixed"] }, { type: i1$1.IonRow, selector: "ion-row" }, { type: i1$1.IonCol, selector: "ion-col", inputs: ["offset", "offsetLg", "offsetMd", "offsetSm", "offsetXl", "offsetXs", "pull", "pullLg", "pullMd", "pullSm", "pullXl", "pullXs", "push", "pushLg", "pushMd", "pushSm", "pushXl", "pushXs", "size", "sizeLg", "sizeMd", "sizeSm", "sizeXl", "sizeXs"] }, { type: i1$1.IonButton, selector: "ion-button", inputs: ["buttonType", "color", "disabled", "download", "expand", "fill", "href", "mode", "rel", "routerAnimation", "routerDirection", "shape", "size", "strong", "target", "type"] }, { type: i1$1.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { type: i2$1.ImageCropperComponent, selector: "image-cropper", inputs: ["imageChangedEvent", "imageURL", "imageBase64", "imageFile", "format", "transform", "maintainAspectRatio", "aspectRatio", "resizeToWidth", "resizeToHeight", "cropperMinWidth", "cropperMinHeight", "cropperMaxHeight", "cropperMaxWidth", "cropperStaticWidth", "cropperStaticHeight", "canvasRotation", "initialStepSize", "roundCropper", "onlyScaleDown", "imageQuality", "autoCrop", "backgroundColor", "containWithinAspectRatio", "hideResizeSquares", "cropper", "alignImage", "disabled"], outputs: ["imageCropped", "startCropImage", "imageLoaded", "cropperReady", "loadImageFailed"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FilePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ctl-file-picker', template: "<div ion-fixed><ion-grid>\n    <ion-row>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"setRatio(1)\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-expand\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"setRatio(0)\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-compress\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\"  color=\"primary\" (click)=\"zoomIn()\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-search-plus\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"zoomOut()\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-search-minus\"></ion-icon> \n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"rotate(-1)\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-undo\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"2\">\n        <ion-button expand=\"full\" size=\"small\" fill=\"clear\" color=\"primary\" (click)=\"rotate(1)\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-redo\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      </ion-row>\n\n      <ion-row>\n        <ion-col size=\"4\">\n          <ion-button size=\"small\" expand=\"full\" fill=\"clear\" color=\"primary\" (click)=\"reset()\">\n            <ion-icon slot=\"icon-only\" class=\"fas fa-trash\"></ion-icon>\n          </ion-button>\n        </ion-col>\n      <ion-col size=\"4\">\n        <ion-button size=\"small\" expand=\"full\" fill=\"clear\" color=\"primary\" (click)=\"temp()\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-expand-arrows-alt\"></ion-icon>\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"4\">\n        <ion-button size=\"small\" expand=\"full\" fill=\"clear\" color=\"primary\" (click)=\"save()\">\n          <ion-icon slot=\"icon-only\" class=\"fas fa-save\"></ion-icon>\n        </ion-button>\n      </ion-col>\n    \n    </ion-row>\n</ion-grid>\n</div>\n\n<image-cropper [hidden]=\"imgTemp == null\"\n    [imageBase64]=\"imgTemp\"\n    [imageChangedEvent]=\"imageChangedEvent\"\n    [maintainAspectRatio]=\"maintainAspectRatio\"\n    [aspectRatio]=\"ratio\"\n    format=\"png\"\n    (imageCropped)=\"imageCropped($event)\"\n    (imageLoaded)=\"imageLoaded()\"\n    (cropperReady)=\"cropperReady()\"\n    (loadImageFailed)=\"loadImageFailed()\"\n    [canvasRotation]=\"canvasRotation\"\n    [transform]=\"transform\"\n></image-cropper>\n\n<image-cropper [hidden]=\"imgTemp != null\"\n    [imageURL]=\"imgTempUrl\"\n    [imageChangedEvent]=\"imageChangedEvent\"\n    [maintainAspectRatio]=\"maintainAspectRatio\"\n    [aspectRatio]=\"ratio\"\n    format=\"png\"\n    (imageCropped)=\"imageCropped($event)\"\n    (imageLoaded)=\"imageLoaded()\"\n    (cropperReady)=\"cropperReady()\"\n    (loadImageFailed)=\"loadImageFailed()\"\n    [canvasRotation]=\"canvasRotation\"\n    [transform]=\"transform\"\n></image-cropper>\n\n", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { imgSrc: [{
                type: Input
            }], croppedImage: [{
                type: Output
            }] } });

class FilePickerComponentModule {
}
FilePickerComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FilePickerComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FilePickerComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FilePickerComponentModule, declarations: [FilePickerComponent], imports: [CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        ImageCropperModule], exports: [FilePickerComponent] });
FilePickerComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FilePickerComponentModule, providers: [], imports: [[
            CommonModule,
            IonicModule,
            FormsModule,
            ReactiveFormsModule,
            ImageCropperModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FilePickerComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FilePickerComponent,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ImageCropperModule
                    ],
                    providers: [],
                    exports: [
                        FilePickerComponent,
                    ],
                    entryComponents: [],
                }]
        }] });

class FileChooserComponent {
    constructor(platform) {
        this.platform = platform;
        this.fileSelected = new EventEmitter();
        this.typeFileImg = new Map(); //--< image de tous les types de fichier
        this.extension = "";
        this.fileName = "";
        this.file = null;
        this.typeAll = ["jpg", "jpeg", "png", "pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "zip", "svg"]; //--< extensions de tous les fichiers acceptes
        this.typeFile = ["jpeg", "png", "pdf", "doc", "ppt", "zip", "svg", "xls", "xlsx", "svg"]; //--< extensions des documents de type 'fichier'
        this.typeImg = ["jpeg", "png", "svg"]; //--< extensions des documents de type 'image'
        this.typeDocument = ["pdf", "doc", "ppt", "xls", "svg"]; //--< extensions des documents de type 'document'
        this.type = ['all']; //--< type des fichiers a charger : all || image || file || document
        this.typeFileImg.set("jpg", "fas fa-file-image");
        this.typeFileImg.set("jpeg", "fas fa-file-image");
        this.typeFileImg.set("png", "fas fa-file-image");
        this.typeFileImg.set("pdf", "fas fa-file-pdf");
        this.typeFileImg.set("doc", "fas fa-file-word");
        this.typeFileImg.set("docx", "fas fa-file-word");
        this.typeFileImg.set("ppt", "fas fa-file-powerpoint");
        this.typeFileImg.set("pptx", "fas fa-file-powerpoint");
        this.typeFileImg.set("xls", "fas fa-file-excel");
        this.typeFileImg.set("xlsx", "fas fa-file-excel");
        this.typeFileImg.set("zip", "fas fa-file-archive");
        this.typeFileImg.set("svg", "fas fa-file-image");
    }
    ngOnInit() {
    }
    /**
     * Fonction qui permet de prendre une photo
     */
    cameraDownload() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let cameraOptions = {
                    quality: 100,
                    maximumImagesCount: 1,
                    allowEditing: true,
                    resultType: CameraResultType.DataUrl
                };
                if (this.platform.is("capacitor")) //--< demande la permission si c est sur un capacitor
                    yield Camera.requestPermissions();
                let result = yield Camera.getPhoto(cameraOptions);
                this.extension = result.format;
                this.fileName = "camera";
                this.file = { name: this.fileName, extension: "image/" + this.extension, data: result.dataUrl };
                this.fileSelected.emit(this.file);
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    /**
     * Fonction qui permet de selectionner un document
     */
    fileDownload(type) {
        console.log("download");
        const fileSelect = document.createElement("input");
        fileSelect.type = "file";
        switch (type) {
            case "image":
                //fileSelect.accept = ".png, .jpeg, .jpg";
                fileSelect.accept = "image/*";
                break;
            case "document":
                //fileSelect.accept = ".pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx";
                fileSelect.accept = "application/*";
                break;
        }
        this.makeFileSelectPretty(fileSelect);
        var self = this;
        fileSelect['onchange'] = function (e) {
            console.log("onchange");
            var selectedFile = e.target['files'][0];
            var reader = new FileReader();
            reader.onload = function (event) {
                var name = fileSelect.value.split('\\').pop().split('/').pop();
                self.fileName = name.substr(0, Math.max(0, name.lastIndexOf(".")));
                self.extension = fileSelect.value.split('.')[1];
                const fileData = event.target['result'];
                if (self.typeAll.includes(self.extension)) {
                    console.log("onchange1");
                    self.selectFile(fileData);
                }
                else {
                    console.log("onchange2");
                    self.file = fileData.toString();
                    self.extension = "";
                }
            };
            reader.readAsDataURL(selectedFile);
        };
        fileSelect.click();
        fileSelect.remove();
    }
    selectFile(fileData) {
        console.log("selectFile");
        var type = fileData.split("/")[0].split(":")[1];
        this.file = { name: this.fileName, extension: type + "/" + this.extension, data: fileData };
        this.fileSelected.emit(this.file);
    }
    makeFileSelectPretty(fileSelect) {
        fileSelect.id = "fileSelect";
        fileSelect['style']['width'] = "100%";
        fileSelect['style']['z-index'] = "99";
        fileSelect['style']['height'] = "100%";
        fileSelect['style']['opacity'] = "0";
        fileSelect['style']['position'] = "absolute";
        fileSelect['style'].left = "0px";
        fileSelect['style'].top = "0px";
    }
}
FileChooserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileChooserComponent, deps: [{ token: i1$1.Platform }], target: i0.ɵɵFactoryTarget.Component });
FileChooserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: FileChooserComponent, selector: "ctl-file-chooser", inputs: { type: "type" }, outputs: { fileSelected: "fileSelected" }, ngImport: i0, template: "<div id=\"fileInputContainer\">\n    <ion-button (click)=\"fileDownload('all')\" *ngIf=\"type.includes('all')\">\n        <ion-icon slot=\"icon-only\" name=\"document-text-outline\"></ion-icon>\n    </ion-button>  \n    <ion-button (click)=\"cameraDownload()\" *ngIf=\"type.includes('camera')\">\n        <ion-icon slot=\"icon-only\" name=\"camera-outline\"></ion-icon>\n    </ion-button>  \n    <ion-button (click)=\"fileDownload('image')\" *ngIf=\"type.includes('image')\">\n        <ion-icon slot=\"icon-only\" name=\"image-outline\"></ion-icon>\n    </ion-button>  \n    <ion-button (click)=\"fileDownload('document')\" *ngIf=\"type.includes('document')\">\n        <ion-icon slot=\"icon-only\" name=\"document-text-outline\"></ion-icon>\n    </ion-button>  \n</div>", styles: ["#fileInputContainer{text-align:center}#imgDocumentSelected{width:50vw;margin:1em 25vw}.extensions{width:5em;margin:.5em;display:inline-block}\n"], components: [{ type: i1$1.IonButton, selector: "ion-button", inputs: ["buttonType", "color", "disabled", "download", "expand", "fill", "href", "mode", "rel", "routerAnimation", "routerDirection", "shape", "size", "strong", "target", "type"] }, { type: i1$1.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileChooserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ctl-file-chooser', template: "<div id=\"fileInputContainer\">\n    <ion-button (click)=\"fileDownload('all')\" *ngIf=\"type.includes('all')\">\n        <ion-icon slot=\"icon-only\" name=\"document-text-outline\"></ion-icon>\n    </ion-button>  \n    <ion-button (click)=\"cameraDownload()\" *ngIf=\"type.includes('camera')\">\n        <ion-icon slot=\"icon-only\" name=\"camera-outline\"></ion-icon>\n    </ion-button>  \n    <ion-button (click)=\"fileDownload('image')\" *ngIf=\"type.includes('image')\">\n        <ion-icon slot=\"icon-only\" name=\"image-outline\"></ion-icon>\n    </ion-button>  \n    <ion-button (click)=\"fileDownload('document')\" *ngIf=\"type.includes('document')\">\n        <ion-icon slot=\"icon-only\" name=\"document-text-outline\"></ion-icon>\n    </ion-button>  \n</div>", styles: ["#fileInputContainer{text-align:center}#imgDocumentSelected{width:50vw;margin:1em 25vw}.extensions{width:5em;margin:.5em;display:inline-block}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.Platform }]; }, propDecorators: { fileSelected: [{
                type: Output
            }], type: [{
                type: Input
            }] } });

class FileChooserComponentModule {
}
FileChooserComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileChooserComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FileChooserComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileChooserComponentModule, declarations: [FileChooserComponent], imports: [CommonModule,
        IonicModule,
        PipesModule,
        FormsModule,
        ReactiveFormsModule], exports: [FileChooserComponent] });
FileChooserComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileChooserComponentModule, providers: [], imports: [[
            CommonModule,
            IonicModule,
            PipesModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileChooserComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FileChooserComponent,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        PipesModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    providers: [],
                    exports: [
                        FileChooserComponent
                    ],
                    entryComponents: [],
                }]
        }] });

class TextRichViewerComponent {
    constructor() {
        this.content = "";
    }
    ngOnInit() {
    }
}
TextRichViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichViewerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TextRichViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: TextRichViewerComponent, selector: "ctl-text-rich-viewer", inputs: { content: "content" }, ngImport: i0, template: "<quill-view-html [content]=\"content\" theme=\"snow\"></quill-view-html>", styles: [""], components: [{ type: i1.QuillViewHTMLComponent, selector: "quill-view-html", inputs: ["content", "theme", "sanitize"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ctl-text-rich-viewer', template: "<quill-view-html [content]=\"content\" theme=\"snow\"></quill-view-html>", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { content: [{
                type: Input
            }] } });

class TextRichViewerComponentModule {
}
TextRichViewerComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichViewerComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TextRichViewerComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichViewerComponentModule, declarations: [TextRichViewerComponent], imports: [CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule, i1.QuillModule], exports: [TextRichViewerComponent] });
TextRichViewerComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichViewerComponentModule, providers: [], imports: [[
            CommonModule,
            IonicModule,
            FormsModule,
            ReactiveFormsModule,
            QuillModule.forRoot({
                modules: {
                    syntax: true
                }
            })
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TextRichViewerComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TextRichViewerComponent,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FormsModule,
                        ReactiveFormsModule,
                        QuillModule.forRoot({
                            modules: {
                                syntax: true
                            }
                        })
                    ],
                    providers: [],
                    exports: [
                        TextRichViewerComponent,
                    ],
                    entryComponents: [],
                }]
        }] });

class GenericListComponent {
    constructor(resolve) {
        this.resolve = resolve;
        this.items = null;
        this.selected = new EventEmitter();
        this.loadDatas = new EventEmitter();
        this.search = new EventEmitter();
        this.searchBar = true;
        this.select = []; //--< tableau des items sélectionnés
        this.multiple = false; //--< selection multiple ou non
        this.scrolling = false;
        this.buttons = null;
        this.terms = "";
    }
    ngOnInit() {
    }
    setDatas(items, buttons = null) {
        this.items = items;
        this.buttons = buttons;
        this.ref.clear();
        for (let index = 0; index < this.items.length; index++) {
            let factory = this.resolve.resolveComponentFactory(this.items[index].component);
            let componentRef = this.ref.createComponent(factory);
            componentRef.instance.datas = this.items[index].datas;
            componentRef.instance.options = this.items[index].options;
            componentRef.instance.parent = this;
        }
    }
    loadingDatas(event) {
        this.loadDatas.emit(event);
    }
    setSelected(ids) {
        this.select = ids;
    }
    /**
     * Fonction qui gère la sélection des items
     * @param id item sélectionné
     */
    addSelected(id) {
        if (!this.multiple)
            this.select = [];
        if (this.select.includes(id))
            this.select.splice(this.select.indexOf(id), 1);
        else
            this.select.push(id);
        this.selected.emit(id);
    }
    isSelected(id) {
        return this.select.includes(id);
    }
    getSelected() {
        return this.select;
    }
    changeSearch() {
        this.search.emit(this.terms);
    }
    toggleInfiniteScroll() {
        this.infiniteScroll.disabled = !this.infiniteScroll.disabled;
    }
}
GenericListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: GenericListComponent, deps: [{ token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
GenericListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: GenericListComponent, selector: "ctl-generic-list", inputs: { items: "items", searchBar: "searchBar", multiple: "multiple", scrolling: "scrolling" }, outputs: { selected: "selected", loadDatas: "loadDatas", search: "search" }, viewQueries: [{ propertyName: "ref", first: true, predicate: ["ref"], descendants: true, read: ViewContainerRef }, { propertyName: "infiniteScroll", first: true, predicate: ["infiniteScroll"], descendants: true, read: IonInfiniteScroll }], ngImport: i0, template: "\n\n<ion-list-header [hidden]=\"!searchBar\" position=\"sticky\"><ion-searchbar animated [(ngModel)]=\"terms\" (ionChange)=\"changeSearch()\"></ion-searchbar></ion-list-header>\n<ion-toolbar *ngIf=\"buttons != null\" position=\"sticky\">\n  <ion-buttons slot=\"end\">\n    <ion-button size=\"small\" slot=\"icon-only\" [id]=\"button.id\" *ngFor=\"let button of buttons\" (click)=\"button.click(button.id)\">\n      <ion-icon [class]=\"button.class\" *ngIf=\"button.class!=''\"></ion-icon>\n      <ion-icon [name]=\"button.name\" *ngIf=\"button.name!=''\"></ion-icon>\n    </ion-button>\n  </ion-buttons>\n</ion-toolbar>\n\n<ion-list #ref></ion-list>\n\n<ion-spinner *ngIf=\"items == null\"></ion-spinner>\n\n<ion-infinite-scroll [hidden]=\"!scrolling\" threshold=\"2%\" (ionInfinite)=\"loadingDatas($event)\">\n  <ion-infinite-scroll-content\n      loadingSpinner=\"bubbles\"\n      loadingText=\"chargement des donn\u00E9es ...\">\n  </ion-infinite-scroll-content>\n</ion-infinite-scroll>\n", styles: ["ion-list{width:100%;display:block;overflow-y:scroll;margin-top:0}#no-data{text-align:center}ion-spinner{display:block;margin:auto}ion-toolbar{zoom:.7;vertical-align:middle;line-height:1em;max-height:2.5em!important}\n"], components: [{ type: i1$1.IonListHeader, selector: "ion-list-header", inputs: ["color", "lines", "mode"] }, { type: i1$1.IonSearchbar, selector: "ion-searchbar", inputs: ["animated", "autocomplete", "autocorrect", "cancelButtonIcon", "cancelButtonText", "clearIcon", "color", "debounce", "disabled", "enterkeyhint", "inputmode", "mode", "placeholder", "searchIcon", "showCancelButton", "showClearButton", "spellcheck", "type", "value"] }, { type: i1$1.IonToolbar, selector: "ion-toolbar", inputs: ["color", "mode"] }, { type: i1$1.IonButtons, selector: "ion-buttons", inputs: ["collapse"] }, { type: i1$1.IonButton, selector: "ion-button", inputs: ["buttonType", "color", "disabled", "download", "expand", "fill", "href", "mode", "rel", "routerAnimation", "routerDirection", "shape", "size", "strong", "target", "type"] }, { type: i1$1.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { type: i1$1.IonList, selector: "ion-list", inputs: ["inset", "lines", "mode"] }, { type: i1$1.IonSpinner, selector: "ion-spinner", inputs: ["color", "duration", "name", "paused"] }, { type: i1$1.IonInfiniteScroll, selector: "ion-infinite-scroll", inputs: ["disabled", "position", "threshold"] }, { type: i1$1.IonInfiniteScrollContent, selector: "ion-infinite-scroll-content", inputs: ["loadingSpinner", "loadingText"] }], directives: [{ type: i1$1.TextValueAccessor, selector: "ion-input:not([type=number]),ion-textarea,ion-searchbar" }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: GenericListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ctl-generic-list', template: "\n\n<ion-list-header [hidden]=\"!searchBar\" position=\"sticky\"><ion-searchbar animated [(ngModel)]=\"terms\" (ionChange)=\"changeSearch()\"></ion-searchbar></ion-list-header>\n<ion-toolbar *ngIf=\"buttons != null\" position=\"sticky\">\n  <ion-buttons slot=\"end\">\n    <ion-button size=\"small\" slot=\"icon-only\" [id]=\"button.id\" *ngFor=\"let button of buttons\" (click)=\"button.click(button.id)\">\n      <ion-icon [class]=\"button.class\" *ngIf=\"button.class!=''\"></ion-icon>\n      <ion-icon [name]=\"button.name\" *ngIf=\"button.name!=''\"></ion-icon>\n    </ion-button>\n  </ion-buttons>\n</ion-toolbar>\n\n<ion-list #ref></ion-list>\n\n<ion-spinner *ngIf=\"items == null\"></ion-spinner>\n\n<ion-infinite-scroll [hidden]=\"!scrolling\" threshold=\"2%\" (ionInfinite)=\"loadingDatas($event)\">\n  <ion-infinite-scroll-content\n      loadingSpinner=\"bubbles\"\n      loadingText=\"chargement des donn\u00E9es ...\">\n  </ion-infinite-scroll-content>\n</ion-infinite-scroll>\n", styles: ["ion-list{width:100%;display:block;overflow-y:scroll;margin-top:0}#no-data{text-align:center}ion-spinner{display:block;margin:auto}ion-toolbar{zoom:.7;vertical-align:middle;line-height:1em;max-height:2.5em!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }]; }, propDecorators: { ref: [{
                type: ViewChild,
                args: ["ref", { read: ViewContainerRef }]
            }], infiniteScroll: [{
                type: ViewChild,
                args: ["infiniteScroll", { read: IonInfiniteScroll }]
            }], items: [{
                type: Input
            }], selected: [{
                type: Output
            }], loadDatas: [{
                type: Output
            }], search: [{
                type: Output
            }], searchBar: [{
                type: Input
            }], multiple: [{
                type: Input
            }], scrolling: [{
                type: Input
            }] } });

class GenericListComponentModule {
}
GenericListComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: GenericListComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GenericListComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: GenericListComponentModule, declarations: [GenericListComponent], imports: [CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        ImageCropperModule], exports: [GenericListComponent] });
GenericListComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: GenericListComponentModule, providers: [], imports: [[
            CommonModule,
            IonicModule,
            FormsModule,
            ReactiveFormsModule,
            ImageCropperModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: GenericListComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GenericListComponent,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ImageCropperModule
                    ],
                    providers: [],
                    exports: [
                        GenericListComponent,
                    ],
                    entryComponents: [],
                }]
        }] });

class OctaliLibUtilsModule {
}
OctaliLibUtilsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OctaliLibUtilsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsModule, declarations: [OctaliLibUtilsComponent], imports: [PipesModule,
        TextPopoverComponentModule,
        CalculatorComponentModule,
        TextRichEditorComponentModule,
        FilePickerComponentModule,
        FileChooserComponentModule,
        TextRichViewerComponentModule,
        GenericListComponentModule], exports: [OctaliLibUtilsComponent,
        PipesModule,
        TextPopoverComponentModule,
        CalculatorComponentModule,
        TextRichEditorComponentModule,
        FilePickerComponentModule,
        FileChooserComponentModule,
        GenericListComponentModule] });
OctaliLibUtilsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsModule, imports: [[
            PipesModule,
            TextPopoverComponentModule,
            CalculatorComponentModule,
            TextRichEditorComponentModule,
            FilePickerComponentModule,
            FileChooserComponentModule,
            TextRichViewerComponentModule,
            GenericListComponentModule
        ], PipesModule,
        TextPopoverComponentModule,
        CalculatorComponentModule,
        TextRichEditorComponentModule,
        FilePickerComponentModule,
        FileChooserComponentModule,
        GenericListComponentModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibUtilsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        OctaliLibUtilsComponent,
                    ],
                    imports: [
                        PipesModule,
                        TextPopoverComponentModule,
                        CalculatorComponentModule,
                        TextRichEditorComponentModule,
                        FilePickerComponentModule,
                        FileChooserComponentModule,
                        TextRichViewerComponentModule,
                        GenericListComponentModule
                    ],
                    exports: [
                        OctaliLibUtilsComponent,
                        PipesModule,
                        TextPopoverComponentModule,
                        CalculatorComponentModule,
                        TextRichEditorComponentModule,
                        FilePickerComponentModule,
                        FileChooserComponentModule,
                        GenericListComponentModule
                    ]
                }]
        }] });

class DisplayerService {
    constructor(loadingCtrl, popoverCtrl, modalCtrl, toastCtrl, alertCtrl) {
        this.loadingCtrl = loadingCtrl;
        this.popoverCtrl = popoverCtrl;
        this.modalCtrl = modalCtrl;
        this.toastCtrl = toastCtrl;
        this.alertCtrl = alertCtrl;
        this.loading = null;
        this.alert = null;
    }
    /**
     * Fonction qui affiche un loader
     * @param text texte afficher par le loader. Par defaut, "veuillez patienter"
     */
    presentLoader(text = "Veuillez patienter") {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loading) {
                this.setMessageLoader(text);
            }
            else {
                this.loading = yield this.loadingCtrl.create({
                    message: text,
                    spinner: "dots"
                });
                this.loading.onDidDismiss().then(() => { });
                yield this.loading.present();
            }
        });
    }
    /**
     * Fonction qui change le texte du loader, si il existe
     * @param message texte a afficher
     */
    setMessageLoader(message) {
        if (this.loading && this.loading.message)
            this.loading.message = message;
    }
    /**
     * Fonction qui supprime le loder, si il existe
     */
    dismissLoader() {
        if (this.loading) {
            this.loading.dismiss();
            this.loading.remove();
            this.loading = null;
        }
    }
    /**
     * Fonction qui affiche un modal
     * @param modalClass Class du modal a afficher
     * @param items Parametres a passer au modal, null par defaut. Ils sont récupéres dans le modal sous le nom 'items'
     * @returns la valeur retournee par le modal a sa fermeture
     */
    presentModal(modalClass, items = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalCtrl.create({
                component: modalClass,
                componentProps: {
                    'items': items,
                }
            });
            yield modal.present();
            return yield (yield modal.onWillDismiss()).data;
        });
    }
    /**
     * Fonction qui affiche un toast
     * @param message message a affiche
     * @param position position du toast, par defaut 'bottom'
     * @param duration duree d'affichage, par defaut 3000ms
     */
    presentToast(message, position = "bottom", duration = 3000) {
        return __awaiter(this, void 0, void 0, function* () {
            let toast = yield this.toastCtrl.create({
                message: message,
                duration: duration,
                position: position
            });
            toast.present();
        });
    }
    /**
     * Fonction qui affiche une fenetre alert
     * @param title titre de la fenetre
     * @param subTitle sous titre de la fenetre
     * @param message message a affiche
     */
    presentAlert(title, subTitle, message) {
        return __awaiter(this, void 0, void 0, function* () {
            this.alert = yield this.alertCtrl.create({
                header: title,
                subHeader: subTitle,
                message: "<span class='justify'>" + message + "<span>",
                buttons: ['OK']
            });
            yield this.alert.present();
        });
    }
    /**
     * Fonction qui affiche une fenetre alert qui demande la saisie d'une valeur
     * @param title titre de la fenetre
     * @param subTitle sous-titre de la fenetre
     * @param name nom de la valeur
     * @param type type de la valeur : "number" | "date" | "email" | "password" | "search" | "tel" | "text" | "url" | "time" | "checkbox" | "radio" | "textarea"
     * @param message message a afficher
     * @param raw retourne la valeur seule ou sous forme de tableau (raw)
     * @returns la valeur saisie ou null
     */
    presentValueAlert(title, subTitle, name, type, message, raw = false) {
        return __awaiter(this, void 0, void 0, function* () {
            this.alert = yield this.alertCtrl.create({
                header: title,
                subHeader: subTitle,
                inputs: [
                    {
                        name: name,
                        placeholder: name,
                        type: type,
                    }
                ],
                message: "<span class='justify'>" + message + "<span>",
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Confirm Cancel');
                            if (this.alert)
                                this.alert.dismiss("");
                        }
                    }, {
                        text: 'Ok',
                        handler: () => {
                            console.log('Confirm Ok');
                        }
                    }
                ]
            });
            yield this.alert.present();
            var data = (yield this.alert.onDidDismiss()).data;
            if (data) {
                if (raw)
                    return data.values;
                else
                    return data.values[name];
            }
            else
                return null;
        });
    }
    /**
     * Fonction qui affiche une fenetre alert qui demande la saisie d'une valeur sous forme de map
     * @param title titre de la fenêtre
     * @param subTitle sous-titre de la fenetre
     * @param nameValue nom des valeurs sour forme de tableau de 2 string
     * @param typeValue type des valeurs sour forme de tableau de 2 string
     * @returns les valeurs saisies ou null
     */
    presentMapAlert(title, subTitle, nameValue, typeValue) {
        return __awaiter(this, void 0, void 0, function* () {
            var message = "Entrez une valeur de type [" + nameValue[0] + ":" + typeValue[0] + " ; " + nameValue[1] + ":" + typeValue[1] + "]";
            this.alert = yield this.alertCtrl.create({
                header: title,
                subHeader: subTitle,
                inputs: [
                    {
                        name: nameValue[0],
                        placeholder: nameValue[0],
                        type: typeValue[0],
                    },
                    {
                        name: nameValue[1],
                        placeholder: nameValue[1],
                        type: typeValue[1],
                    }
                ],
                message: "<span class='justify'>" + message + "<span>",
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Confirm Cancel');
                            if (this.alert)
                                this.alert.dismiss("");
                        }
                    }, {
                        text: 'Ok',
                        handler: () => {
                            console.log('Confirm Ok');
                        }
                    }
                ]
            });
            yield this.alert.present();
            var data = (yield this.alert.onDidDismiss()).data;
            if (data)
                return data.values;
            else
                return null;
        });
    }
    /**
     * Fonction qui affiche une fenetre alert avec plusieurs boutons et retourn le bouton clique
     * @param title titre de la fenêtre
     * @param subTitle soius-titre de la fenetre
     * @param message texte a afficher
     * @param buttons nom des boutons sous forme de tableau de string
     * @returns le bouton clique ou null
     */
    presentAlertMultipleButtons(title, subTitle, message, buttons) {
        return __awaiter(this, void 0, void 0, function* () {
            let buttonsAlert = [];
            buttons.forEach(button => {
                buttonsAlert.push({ text: button, handler: () => {
                        if (this.alert)
                            this.alert.dismiss(button);
                        return false;
                    } });
            });
            this.alert = yield this.alertCtrl.create({
                header: title,
                subHeader: subTitle,
                message: "<span class='justify'>" + message + "<span>",
                buttons: buttonsAlert
            });
            yield this.alert.present();
            var data = (yield this.alert.onDidDismiss()).data;
            if (data)
                return data;
            else
                return null;
        });
    }
    /**
     * Fonction qui affiche une fenetre alert avec plusieurs boutons et retourn le nom du bouton clique
     * @param title titre de la fenêtre
     * @param subTitle soius-titre de la fenetre
     * @param message texte a afficher
     * @param buttons nom des boutons sous forme de tableau de string
     * @returns le nom du bouton clique ou null
     */
    presentAlertMultipleValuesButtons(title, subTitle, message, buttons) {
        return __awaiter(this, void 0, void 0, function* () {
            let buttonsAlert = [];
            buttons.forEach(button => {
                buttonsAlert.push({ text: button.text, handler: () => {
                        if (this.alert)
                            this.alert.dismiss(button.value);
                        return false;
                    } });
            });
            this.alert = yield this.alertCtrl.create({
                header: title,
                subHeader: subTitle,
                message: "<span class='justify'>" + message + "<span>",
                buttons: buttonsAlert
            });
            yield this.alert.present();
            var data = (yield this.alert.onDidDismiss()).data;
            if (data)
                return data;
            else
                return null;
        });
    }
    /**
     * Fonction qui affiche un popover affichant un simple texte
     * @param ev l'evenement source
     * @param message message a afficher
     * @returns void
     */
    presentTextPopover(ev, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const popover = yield this.popoverCtrl.create({
                component: TextPopoverComponent,
                componentProps: { message: message },
                event: ev,
                translucent: true
            });
            return yield popover.present();
        });
    }
}
DisplayerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DisplayerService, deps: [{ token: i1$1.LoadingController }, { token: i1$1.PopoverController }, { token: i1$1.ModalController }, { token: i1$1.ToastController }, { token: i1$1.AlertController }], target: i0.ɵɵFactoryTarget.Injectable });
DisplayerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DisplayerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: DisplayerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.LoadingController }, { type: i1$1.PopoverController }, { type: i1$1.ModalController }, { type: i1$1.ToastController }, { type: i1$1.AlertController }]; } });

class LoggerService {
    constructor() {
        this.debug = true;
    }
    setDebugMode(mode) {
        this.debug = mode;
    }
    getDebugMode() {
        return this.debug;
    }
    message(source, message, type = "info") {
        if (this.debug)
            switch (type) {
                case "debug":
                    console.log("[" + source + "] " + message);
                    break;
                case "info":
                    console.info("[" + source + "] " + message);
                    break;
                case "warn":
                    console.warn("[" + source + "] " + message);
                    break;
                case "err":
                    console.error("[" + source + "] " + message);
                    break;
                default:
                    console.log("[" + source + "] " + message);
            }
    }
    object(source, obj, type = "info") {
        if (this.debug)
            switch (type) {
                case "log":
                    console.log("[" + source + "] ", obj);
                    break;
                case "info":
                    console.info("[" + source + "] ", obj);
                    break;
                case "warn":
                    console.warn("[" + source + "] ", obj);
                    break;
                case "err":
                    console.error("[" + source + "] ", obj);
                    break;
                default:
                    console.log("[" + source + "] ", obj);
            }
    }
}
LoggerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: LoggerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LoggerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: LoggerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: LoggerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class EventService {
    constructor(logger) {
        this.logger = logger;
        this.events = new Map();
    }
    /**
     * Fonction qui publie une nouvelle valeur pour un evenement.
     * Si l'evenement exite, on met à la jour sa valeur
     * Si l'evenement n'existe pas, on le créé et on l'initialise
     * @param key nom de l'evenement a traiter
     * @param value valeur a publier
     */
    publish(key, value) {
        if (this.events.has(key)) { //--< l'evenement exite-t-il?
            this.events.get(key).next(value);
        }
        else {
            let newSubject = new BehaviorSubject(value);
            this.events.set(key, newSubject);
        }
    }
    /**
     * Fonction qui récupère la valeur d'un evenement et la retourne
     * Si l'evenement n'existe pas, on le créé et on l'initialise
     * @param key nom de l'evenement a traiter
     * @param value valeur de l'evenement, null par défaut
     * @returns la valeur de l'evenement
     */
    get(key, value = null) {
        if (this.events.has(key)) {
            return this.events.get(key);
        }
        else {
            let newSubject = new BehaviorSubject(value);
            this.events.set(key, newSubject);
            return newSubject;
        }
    }
    /**
     * Fonction qui supprime un evenement
     * @param key evenement a supprimer
     * @return retourne vrai si réussi, false si l'evenement n'existe pas
     */
    remove(key) {
        if (this.events.has(key)) {
            try {
                this.events.get(key).complete();
                this.events.delete(key);
                return true;
            }
            catch (e) {
                this.logger.object(LoggerService.name, e, "err");
                return false;
            }
        }
        else
            return false;
    }
}
EventService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: EventService, deps: [{ token: LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
EventService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: EventService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: EventService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LoggerService }]; } });

/*
 * Public API Surface of octali-lib-utils
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CalculatorComponent, CalculatorComponentModule, DisplayerService, EventService, FileChooserComponent, FileChooserComponentModule, FilePickerComponent, FilePickerComponentModule, GenericListComponent, GenericListComponentModule, LoggerService, OctaliLibUtilsComponent, OctaliLibUtilsModule, OctaliLibUtilsService, PipesModule, SearchPipe, SearchValuePipe, SortKeyPipe, SortMapPipe, SortPipe, SortValuePipe, TextPopoverComponent, TextPopoverComponentModule, TextRichEditorComponent, TextRichEditorComponentModule, TextRichViewerComponent, TextRichViewerComponentModule };
